import React, {useCallback, useMemo, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import _, { isUndefined } from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyLiabilityComponent.metadata.json5';
import styles from "./PolicyLiabilityComponent.module.scss";
import { IntlContext } from '@jutro/locale';
import {formatNumber} from '@jutro/components';

const getLimitDeductible = (items,property) => {
    let amount = "-";
   if (items.terms.length > 0) {
    items.terms.forEach(function(term) {
        if (term?.modelType?.toUpperCase() === property.toUpperCase() ||
            term?.name?.toUpperCase() === property.toUpperCase()) {
            amount = term.amount;
        }
    });
    }
   return amount;
};

const getCellCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellCoverageLimit = (rowData, intl) => {
    var totalLimit = rowData.totalLimit ?  rowData.totalLimit : rowData.limit
    var formatedlimit =  formatNumber(intl, { format: 'decimal', showFractions: true}, totalLimit)

    if  (totalLimit) {
    return (
        <span>            
            {formatedlimit == "NaN" ? totalLimit : formatedlimit }
        </span>
    );}
    else{
    return (
        <span>
            {getLimitDeductible(rowData,'Limit')}
        </span>
            
    );}
};

const getCellCoverageDeductible = (rowData) => {
 if  (_.isEmpty(rowData.deductible)) {
     return (
        <span>
            {getLimitDeductible(rowData,'Deductible')}
        </span>
    );
}
else {
return (
        <span>
            {rowData.deductible}
        </span>
    );
}
};

const getCellLiabilityExtensionName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
}; 

const getCellAggregateLimit = (rowData, intl) => {
    const aggregateLimit = rowData.aggregateLimit ? formatNumber(intl, { format: 'decimal', showFractions: true}, rowData.aggregateLimit) : getLimitDeductible(rowData, "Aggregate Limit")
    return (
        <span>
            {aggregateLimit}
        </span>
    );
};

const getCellLiabilityUnderWritingClassesName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};


function PolicyLiabilityComponent(props) {
    const { value: currentPeriodDetails } = props;
    const intl = useContext(IntlContext);
    if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    }

    const getLobData = (currentDetails) => {
        const { productName } = currentDetails;
        let lData = '';
        // eslint-disable-next-line default-case
        switch (productName) {
            case 'Commercial Property':
                lData = currentDetails.lobs.commercialProperty;
                break;
            case 'Residential':
                lData = currentDetails.lobs.homeOwners;
                break;
			case 'Farm':
                lData = currentDetails.lobs.homeOwners;
                break;
			case 'Marine':
                lData = currentDetails.lobs.homeOwners;
                break;        }
        return lData;
    };

    const lobData = getLobData(currentPeriodDetails);

    const removeExcessLiability = (coverageList) => {
        if(coverageList && coverageList.length > 0){
            return coverageList.filter((coverage) => {
                return coverage.name != 'Excess Liability Coverage'
            })
        }
        return [];
    };

    const policyLiabilityCoverables = useMemo(() => {
        let coverages = lobData.liabilityCoverageDTOs;  
        let liabilityCoverages = removeExcessLiability(coverages);
        if(liabilityCoverages && liabilityCoverages.length > 0){
           return _.sortBy(liabilityCoverages, 'name');
        }
        return [];
    }, [currentPeriodDetails]);

    const policyLiabilityExtensions = useMemo(() => {
        const liabilityCoverages = lobData.liabilityExtensions;
        const liabilityExtensions = [];
        if (liabilityCoverages) {
            liabilityCoverages.forEach((coverage) => {
                if (coverage.riskExposure === false) {
                    liabilityExtensions.push(coverage);
                }
            });
         }
        return liabilityExtensions;
    }, [lobData]);

    const policyLiabilityUnderWritingClasses = useMemo(() => {
        const liabilityCoverages = lobData.liabilityExtensions;
        const liabilityUW = [];
        if (liabilityCoverages) {
            liabilityCoverages.forEach((coverage) => {
                if (coverage.riskExposure === true) {
                    liabilityUW.push(coverage);
                }
            });
        }
        return liabilityUW;
    }, [lobData]);

    const generateLiabilityTableOverrides = useCallback(() => {
        return {
             coverageColumn: { onCell: getCellCoverageName },
             limitColumn: { onCell: (rowData)=>{return getCellCoverageLimit(rowData, intl)} ,
                header: currentPeriodDetails.productName === 'Commercial Property'? "Limit" : "Limit"
             },
             aggregateLimitColumn: { onCell: (rowData)=>{return getCellAggregateLimit(rowData, intl)}, 
                visible: currentPeriodDetails.productName === 'Commercial Property',
             },
             deductibleColumn: { onCell: getCellCoverageDeductible } 
        };
    }, [policyLiabilityCoverables]);

    const generateLiabilityExtensionsTableOverrides = useCallback(() => {
        return {
            liabilityExtensionsColumn: { onCell: getCellLiabilityExtensionName }
        };
    }, [policyLiabilityExtensions]);

    const overrides = {
        PolicyLiability: {
            data: lobData
        },
        policyLiabilityTable: {
            data: policyLiabilityCoverables
        },
        policyLiabilityExtensionsTable: {
            data: policyLiabilityExtensions,
            visible: !_.isEmpty(policyLiabilityExtensions)
        },
        policyLiabilityUwClassesTable: {
            data: policyLiabilityUnderWritingClasses,
            visible: !_.isEmpty(policyLiabilityUnderWritingClasses)
        },
        liabilityUnderWritingClassesColumn: {
            onCell: getCellLiabilityUnderWritingClassesName
        },
        noLiabilityLabel: {
            visible: _.isEmpty(policyLiabilityUnderWritingClasses) && _.isEmpty(policyLiabilityExtensions) && _.isEmpty(policyLiabilityCoverables)
        },
        // marineLiabilityNote: {
        //     visible: currentPeriodDetails.productName === 'Marine' && !(_.isEmpty(policyLiabilityCoverables))
        // },
        ...generateLiabilityTableOverrides(),
        ...generateLiabilityExtensionsTableOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={lobData}
            overrideProps={overrides}
        />
    );
}


PolicyLiabilityComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyLiabilityComponent.defaultProps = {
    value: {
        // lobData: {},
        // liabilityCoverageDTOs: [],
        // liabilityExtensions: []
    }
};

export default PolicyLiabilityComponent;
